<template>
  <transition name="modal-register">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <icon-32 class="modal-close-button" clickable name="close" @click="$emit('close')" />
          <div class="modal-content">
            <div class="modal-header dark-color">
              <slot name="header"></slot>
            </div>

            <div class="modal-body">
              <slot name="body"></slot>
            </div>

            <div class="modal-footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Icon32 from '@/components/icons/Icon32'

export default {
  components: { Icon32 }
}
</script>

<style scoped>
.modal-enter { opacity: 0; }
.modal-leave-active { opacity: 0; }
.modal-enter .modal-container,
.modal-leave-active .modal-container { -webkit-transform: scale(1.1); -moz-transform: scale(1.1); -o-transform: scale(1.1); transform: scale(1.1); }
.modal-mask { font-size: 12px; position: fixed; z-index: 9998; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, .5); display: table; transition: opacity .3s ease; }
.modal-wrapper { display: table-cell; vertical-align: middle; }
.modal-container { margin: 0px auto; position: relative; width: 300px; -webkit-transition: transform .3s; -moz-transition: transform .3s; -o-transition: transform .3s; transition: transform .3s; }
.modal-content { padding: 15px 15px; background-color: #fff; border-radius: 2px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33); overflow: hidden; position: relative; transition: all .3s ease; }
.modal-content:before { border-radius: 2px; bottom: -50px; box-shadow: inset 0 0 100px rgba(0, 0, 0, .1); content: ''; left: 0; position: absolute; right: 0; top: -50px; z-index: 0; }
.modal-header { font-size: 16px; position: relative; text-align: center; z-index: 1; }
.modal-body { margin: 15px 0; position: relative; z-index: 1; }
.modal-footer { display: flex; justify-content: center; position: relative; z-index: 1; }
.modal-default-button:not(:first-child) { margin-left: 5px; }
.modal-close-button { right: -16px; position: absolute; top: -16px; z-index: 9998; }
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalRegister.vue